import {
  handleOpenInNewTab as sharedHandleOpenInNewTab,
  clearDocumentTabsTracking,
} from './tabManager'

const DECISION_TYPES = ['cd', 'md', 'fta', 'ad', 'zd', 'td', 'bl', 'er', 'ers', 'ir', 'eb', 'jd']
const GUIDE_TYPES = ['guide', 'pc', 'manual', 'circular', 'tbc']
const SUPPORTED_DOC_TYPES = ['article', ...DECISION_TYPES, ...GUIDE_TYPES]

const DOC_TYPE_LABELS = {
  article: 'Article',
  cd: 'CD',
  md: 'MD',
  fta: 'FTA',
  ad: 'AD',
  zd: 'ZD',
  td: 'TD',
  bl: 'BL',
  er: 'ER',
  ers: 'ERS',
  ir: 'IR',
  eb: 'EB',
  jd: 'JD',
  guide: 'Guide',
  pc: 'PC',
  manual: 'Manual',
  circular: 'Circular',
  tbc: 'TBC',
}

const toTitleCase = (value = '') =>
  value
    .split(' ')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ')

export const handleEmail = (article) => {
  if (!article) return

  // Function to parse the article slug
  const parseSlug = (slug) => {
    if (!slug) return { country: '', lawName: '', docInfo: '' }

    const parts = slug.split('-').filter(Boolean)
    const normalizedParts = parts.map((part) => part.toLowerCase())

    // DTAA pattern: country1Code-country2Code-dtaa
    if (parts.length === 3 && normalizedParts[2] === 'dtaa') {
      return {
        country: `${parts[0].toUpperCase()} - ${parts[1].toUpperCase()}`,
        lawName: 'DTAA',
        docInfo: '',
      }
    }

    // Extract country (first part)
    const country = parts[0]?.toUpperCase() || ''

    // Find where the document type starts (after law identifier)
    let lawEndIndex = -1

    for (let i = 1; i < parts.length; i++) {
      if (SUPPORTED_DOC_TYPES.includes(normalizedParts[i])) {
        lawEndIndex = i
        break
      }
    }

    // Extract law name (between country and document type)
    let lawName = ''
    if (lawEndIndex > 1) {
      const lawParts = parts.slice(1, lawEndIndex)
      // lawName = lawParts.join(' ').replace(/\b\w/g, (l) => l.toUpperCase()) // Capitalize first letter of each word
      lawName = lawParts.join(' ').toUpperCase() // Make all letters uppercase for consistency
    }

    // Extract document info (from document type onwards)
    let docInfo = ''
    if (lawEndIndex !== -1) {
      const docType = normalizedParts[lawEndIndex]
      const docIdentifierParts = parts.slice(lawEndIndex + 1)
      const docIdentifier = docIdentifierParts.join(' ')

      // Format document type
      const formattedDocType = DOC_TYPE_LABELS[docType] || docType.toUpperCase()

      // Format document identifier
      let formattedIdentifier = docIdentifier
      if (docType === 'article' && docIdentifier) {
        // For articles, just show the number
        formattedIdentifier = docIdentifier.replace(/^0+/, '') || docIdentifier
      } else if (DECISION_TYPES.includes(docType)) {
        // Decision-type identifiers are typically numeric/year tokens.
        formattedIdentifier = docIdentifier.replace(/-/g, ' ').toUpperCase()
      } else if (GUIDE_TYPES.includes(docType)) {
        // Guide-type identifiers are usually descriptive text.
        formattedIdentifier = toTitleCase(docIdentifier.replace(/-/g, ' '))
      } else {
        formattedIdentifier = docIdentifier.replace(/-/g, ' ')
      }

      docInfo = `${formattedDocType}${
        formattedIdentifier ? ` ${formattedIdentifier}` : ''
      }`
    }

    return { country, lawName, docInfo }
  }

  // Get article title for body
  const articleTitle = article?.name || article?.title || 'a GCC Tax Document'

  // Parse the slug to get formatted parts
  const { country, lawName, docInfo } = parseSlug(article?.slug)

  // Create subject with parsed information
  let subjectParts = ['GCCTaxLaws.com']
  if (country) subjectParts.push(country)
  if (lawName) subjectParts.push(lawName)
  if (docInfo) subjectParts.push(docInfo)

  const subject = encodeURIComponent(subjectParts.join(' || '))

  // Create body with title
  const body = encodeURIComponent(`
Hi there,

I came across a document titled "${articleTitle}" on GCCTaxLaws.com that might be of interest to you.

You can view it here: ${window.location.href}

Best regards,
`)

  window.location.href = `mailto:?subject=${subject}&body=${body}`
}

// Use the shared tab manager
export const handleOpenInNewTab = sharedHandleOpenInNewTab

// Export the shared cleanup function
export { clearDocumentTabsTracking }
